import { useCallback, useState } from 'react';
import { isHtmlContentEmpty } from './basicInfoContentUtils';

export function useTemplateApplyConfirm() {
  const [pendingReplace, setPendingReplace] = useState<(() => void) | null>(
    null,
  );

  const requestApply = useCallback(
    (
      templateContent: string,
      currentContent: string | undefined,
      apply: (content: string) => void,
    ) => {
      if (isHtmlContentEmpty(currentContent)) {
        apply(templateContent);
        return;
      }
      setPendingReplace(() => () => {
        apply(templateContent);
        setPendingReplace(null);
      });
    },
    [],
  );

  const dismiss = useCallback(() => setPendingReplace(null), []);

  const confirmReplace = useCallback(() => {
    pendingReplace?.();
  }, [pendingReplace]);

  return {
    isConfirmOpen: pendingReplace !== null,
    requestApply,
    dismiss,
    confirmReplace,
  };
}
